import { FC } from 'react';

import cn from 'classnames';

import { CenteredSpin } from '@//components/common';

import styles from './CenteredLoaderWithBlur.module.scss';

type Props = {
	isLoading: boolean;
};

export const CenteredLoaderWithBlur: FC<Props> = ({ isLoading }) => {
	return (
		<>
			<div
				className={cn({
					[styles.bgBlur]: isLoading,
				})}
			/>
			{isLoading && <CenteredSpin />}
		</>
	);
};
